import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import { useStore, useTokens } from '@mcn-platform/models';
import CustomButton from '../common/CustomButton';
import AccountDialogs from './AccountDialogs';
const AccountButton = ({ useLabelsForSignInMyAccount = false }) => {
    const [showDialog, setShowDialog] = useState();
    const navigate = useNavigate();
    const store = useStore();
    const tokens = useTokens();
    const handleButtonClick = () => {
        if (store.isAnonymous) {
            setShowDialog('SIGN-IN');
        }
        else {
            setShowDialog(undefined);
            navigate('account');
        }
    };
    const label = store.isAnonymous ? tokens.getToken('signInLabel') : tokens.getToken('myAccountLabel');
    return (_jsxs(_Fragment, { children: [useLabelsForSignInMyAccount ? (_jsx(CustomButton, { label: label, onClick: handleButtonClick })) : (_jsx(IconButton, { className: "primary", sx: {
                    color: 'common.white',
                    border: '1px solid white',
                }, onClick: handleButtonClick, children: _jsx(PersonOutlineIcon, { color: "inherit" }) })), _jsx(AccountDialogs, { showDialog: showDialog, setShowDialog: setShowDialog, handleClose: () => setShowDialog(undefined) })] }));
};
AccountButton.defaultProps = {
    useLabelsForSignInMyAccount: true,
};
export default AccountButton;
//# sourceMappingURL=AccountButton.js.map